import { useI18n } from '../i18n/I18nProvider';
import { Button } from '../ui/Button';
import { Icon } from '../ui/Icon';
import { MoonMark } from '../ui/MoonMark';

export function TopBar(
  { session, nickname, onAuth, onSettings }:
  {
    session: { uid: string } | null;
    /** 玩家昵称。还没拉到时是 null，先显示 uid 前几位顶着 */
    nickname: string | null;
    onAuth(): void;
    onSettings(): void;
  },
) {
  const { t } = useI18n();
  return (
    <header className="topbar">
      <div className="topbar__brand" aria-label="LaroLuna">
        <MoonMark className="topbar__moon" />
        <span className="topbar__wordmark">LaroLuna</span>
      </div>

      <div className="topbar__right">
        {session ? (
          // 登录之后这里换成账号入口，显示昵称。**不显示手机号** —— 顶栏是最容易
          // 被旁人看到的地方，也最容易被截图发出去
          <Button variant="ghost" className="topbar__account" onClick={onAuth}
                  aria-label={t('action.myAccount')}>
            <Icon name="user" className="topbar__uicon" />
            <span className={nickname ? 'topbar__nick' : 'topbar__nick num'}>
              {nickname ?? session.uid.slice(0, 6)}
            </span>
          </Button>
        ) : (
          <Button variant="primary" onClick={onAuth}>{t('action.loginOrRegister')}</Button>
        )}
        <Button variant="icon" onClick={onSettings} aria-label={t('action.settings')}>
          <Icon name="settings" />
        </Button>
      </div>
    </header>
  );
}
